import type { TOC } from '@ember/component/template-only'
import { ThStandard } from 'teacher-ui-client/components/th/standard'
import { t, formatDate } from 'ember-intl'
import type { ComprehensionProgressPlacementEvent } from 'teacher-ui-client/reporting/ui-scope/rex/dashboard/student/index/route'
import { colspanMax } from 'teacher-ui-client/modifiers/colspan-max'

interface Args {
  isLoading: boolean
  eventsData: ComprehensionProgressPlacementEvent[]
}

interface Signature {
  Args: Args
  Element: HTMLTableElement
}

export const ComprehensionProgressPlacementEventsDetailed: TOC<Signature> = <template>
  <table class="divide-oceany-blue-150 border-oceany-blue-150 divide-y border-b" ...attributes>
    <thead>
      <tr class="bg-oceany-blue-50 divide-x divide-white">
        <ThStandard class="w-40">
          {{t "components.reporting.tables.readingEggspress.dashboardStudent.headers.date"}}
        </ThStandard>
        <ThStandard>
          {{t "components.reporting.tables.readingEggspress.dashboardStudent.headers.lessonName"}}
        </ThStandard>
      </tr>
    </thead>
    <tbody class="divide-oceany-blue-150 divide-y {{if @isLoading 'opacity-50'}}">
      {{#each @eventsData as |event|}}
        <tr>
          <td class="p-3">{{formatDate event.created_at day="2-digit" month="short" year="numeric"}}</td>
          <td class="p-3">
            {{t
              "components.reporting.tables.readingEggspress.dashboardStudent.lessonEventRow"
              number=event.lesson
              name=event.lesson_name
            }}
          </td>
        </tr>
      {{else}}
        <tr>
          <td data-test-empty-message class="p-3 text-center italic" {{colspanMax}}>
            {{t "components.reporting.tables.readingEggspress.dashboardStudent.eventsEmptyMessage"}}
          </td>
        </tr>
      {{/each}}
    </tbody>
  </table>
</template>

export default ComprehensionProgressPlacementEventsDetailed
